module.exports = {
    familiasData: () => {
        return[
            {
                "Familias":[
                    {
                        "Familia":"TRABAJO Y TRANSPORTE",
                        "Motos":[
                            {
                                "Moto":"TVS SPORT",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-sport.svg")
                            },
                            {
                                "Moto":"STRYKER",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/stryker.svg")
                            },
                            {
                                "Moto":"TVS MAX",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-max.svg")
                            }
                        ]
                    },
                    {
                        "Familia":"DEPORTIVAS",
                        "Motos":[
                            {
                                "Moto":"TVS APACHE",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-apache.svg")
                            },
                            {
                                "Moto":"TVS RAIDER",
                                "Logo":require("./../UI/general/Sidebar/btns-motos/raider/Raider.svg")
                            }
                        ]
                    },
                    {
                        "Familia":"SCOOTER",
                        "Motos":[
                            {
                                "Moto":"TVS NTORQ",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-ntorq.svg")
                            }
                        ]
                    },
                    {
                        "Familia":"SEMI AUTOMÁTICAS",
                        "Motos":[
                            {
                                "Moto":"TVS NEO NX",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-neo-nx.svg")
                            }
                        ]
                    },
                    {
                        "Familia":"MOTOCARROS",
                        "Motos":[
                            {
                                "Moto":"TVS KING",
                                "Logo":require("./../UI/general/Sidebar/logos-motos/tvs-king.svg")
                            }
                        ]
                    }
                ]
            }
        ]
    }
}